export default "__VITE_ASSET__a_XzufvG__"